import { useCallback, useState } from 'react'

import copy from 'copy-to-clipboard'

import { actionTypes } from 'actions/actionTypes'

import type { ShareSurface } from './shareNatively'
import { shareNatively } from './shareNatively'
import { SOCIAL_TYPES } from './socialReferralHelper'

type UseShareWithFallbackArgs = {
  copyText: string
  surface: ShareSurface
  trackingReferFriend: (actionType: string, actionName: string) => void
  trackUserFreeFoodLinkShare: (payload: { target: string }) => void
  onOpened?: () => void
}

export const useShareWithFallback = ({
  copyText,
  surface,
  trackingReferFriend,
  trackUserFreeFoodLinkShare,
  onOpened,
}: UseShareWithFallbackArgs) => {
  const [isCopied, setIsCopied] = useState<boolean>(false)

  const copyToClipboard = useCallback(() => {
    if (!copy(copyText)) {
      return
    }

    setIsCopied(true)
    trackingReferFriend(actionTypes.REFER_FRIEND_LINK_COPIED, 'ReferFriendLink Copied')
    trackUserFreeFoodLinkShare({ target: SOCIAL_TYPES.link })
  }, [copyText, trackingReferFriend, trackUserFreeFoodLinkShare])

  const share = useCallback(
    (payload: ShareData) => {
      // Clear any confirmation left over from a previous fallback copy — this attempt might
      // succeed natively this time, in which case nothing was copied and the message would be stale.
      setIsCopied(false)

      shareNatively({
        payload,
        surface,
        onOpened,
        onFallback: copyToClipboard,
      })
    },
    [surface, onOpened, copyToClipboard],
  )

  return { isCopied, share }
}
